"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useComposerProps;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _createAdaptiveCardsAttachmentMiddleware = _interopRequireDefault(require("./adaptiveCards/createAdaptiveCardsAttachmentMiddleware"));

var _createAdaptiveCardsStyleSet = _interopRequireDefault(require("./adaptiveCards/Styles/createAdaptiveCardsStyleSet"));

var _renderMarkdown = _interopRequireDefault(require("./renderMarkdown"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useComposerProps(_ref) {
  var attachmentMiddleware = _ref.attachmentMiddleware,
      renderMarkdown = _ref.renderMarkdown,
      styleOptions = _ref.styleOptions,
      styleSet = _ref.styleSet;
  var patchedAttachmentMiddleware = (0, _react.useMemo)(function () {
    return (0, _botframeworkWebchatComponent.concatMiddleware)(attachmentMiddleware, (0, _createAdaptiveCardsAttachmentMiddleware.default)());
  }, [attachmentMiddleware]);
  var patchedStyleOptions = (0, _react.useMemo)(function () {
    return _objectSpread({}, _botframeworkWebchatComponent.defaultStyleOptions, {}, styleOptions);
  }, [styleOptions]); // When styleSet is not specified, the styleOptions will be used to create Adaptive Cards styleSet and merged into useStyleSet.

  var extraStyleSet = (0, _react.useMemo)(function () {
    return styleSet ? undefined : (0, _createAdaptiveCardsStyleSet.default)(patchedStyleOptions);
  }, [patchedStyleOptions, styleSet]);
  return {
    attachmentMiddleware: patchedAttachmentMiddleware,
    extraStyleSet: extraStyleSet,
    renderMarkdown: typeof renderMarkdown === 'undefined' ? function (text) {
      return (0, _renderMarkdown.default)(text, patchedStyleOptions);
    } : renderMarkdown
  };
}